/**
 * Longitudes alineadas con reglas / maxLength en Form01, Form02 y Form03 (Colombia Vida).
 */
const L = {
  FIRST_NAME: 15,
  SECOND_FIRST_NAME: 15,
  /** Apellidos en Form01 sin max explícito; mismo criterio que nombres */
  LAST_NAME: 15,
  SECOND_LAST_NAME: 15,
  EMAIL: 150,
  IDENTIFICATION: 15,
  OCUPACITY: 30,
  ADDRESS: 30,
  CITY: 30,
  APART: 30,
  PHONE: 10,
  PHONE_OFFICE: 20,
  /** groupNumber sin max en template; valor de prueba razonable */
  GROUP_NUMBER: 30,
  /** Form02 b-form-input maxLength */
  BENEF_NAME: 25,
  BENEF_LAST_NAME: 25,
  BENEF_DOCUMENT: 15,
  /** Form03 padecimientos */
  PAD_TRATAMIENTO: 60,
  PAD_MEDICO: 40,
};

/**
 * Rellena el formulario Colombia Vida con valores de prueba al máximo de longitud permitido
 * en validaciones (textos) y completa todos los beneficiarios y las 4 filas de padecimientos.
 * @param {Object} form — objeto del wizard (se muta)
 */
export function fillColombiaVidaDemoMax(form) {
  const max = (n, ch) => String(ch).repeat(n).slice(0, n);

  /* --- Form01: textos al máximo --- */
  form.firstName = max(L.FIRST_NAME, "N");
  form.secondFirstName = max(L.SECOND_FIRST_NAME, "S");
  form.lastName = max(L.LAST_NAME, "L");
  form.secondLastName = max(L.SECOND_LAST_NAME, "A");

  form.identificationType = "TI";
  form.identification = max(L.IDENTIFICATION, "1");
  form.ocupacity = max(L.OCUPACITY, "O");
  form.adress = max(L.ADDRESS, "D");
  form.city = max(L.CITY, "C");
  form.apart = max(L.APART, "A");

  form.phone = max(L.PHONE, "3");
  form.phoneOffice = max(L.PHONE_OFFICE, "4");
  form.phoneMobile = max(L.PHONE, "5");

  if (form.groupNumber === undefined || form.groupNumber === "") {
    form.groupNumber = max(L.GROUP_NUMBER, "G");
  }

  if (form.procedimiento === "INCLUSION") {
    form.birthDay = "1990-05-15";
    form.stature = "1.75";
    form.weight = "75";
  }

  /* --- Beneficiarios: todos los ítems del array, suma 100 %, documentos únicos --- */
  if (!Array.isArray(form.beneficiarios) || form.beneficiarios.length === 0) {
    form.beneficiarios = [
      {
        name: "",
        lastName: "",
        documentType: "",
        document: "",
        birthDay: "",
        relation: "",
        sex: "",
        percentage: "",
      },
      {
        name: "",
        lastName: "",
        documentType: "",
        document: "",
        birthDay: "",
        relation: "",
        sex: "",
        percentage: "",
      },
    ];
  }

  const relacionesUnicos = ["CY", "HJ", "HN", "MD", "PD"];
  const n = form.beneficiarios.length;

  const each = n === 1 ? 100 : Math.floor((100 / n) * 100) / 100;
  let assigned = 0;

  form.beneficiarios.forEach((b, i) => {
    const letra = String.fromCharCode(65 + (i % 26));
    b.name = max(L.BENEF_NAME, letra);
    b.lastName = max(L.BENEF_LAST_NAME, String.fromCharCode(97 + (i % 26)));
    b.documentType = "CC";
    b.document = String(i).padStart(L.BENEF_DOCUMENT, "0");
    b.birthDay = "2000-06-15";
    b.relation = i < relacionesUnicos.length ? relacionesUnicos[i] : "OT";
    b.sex = i % 2 === 0 ? "M" : "F";
    if (n === 1) {
      b.percentage = 100;
    } else if (i < n - 1) {
      b.percentage = each;
      assigned += each;
    } else {
      b.percentage = Math.round((100 - assigned) * 100) / 100;
    }
  });

  /* --- Form03: ambas preguntas Sí + 4 padecimientos completos --- */
  form.illnessDeclaration = "S";
  form.incapacityDeclaration = "S";
  form.padecimientos = [0, 1, 2, 3].map((i) => ({
    pregunta: i < 2 ? "1" : "2",
    tratamiento: max(L.PAD_TRATAMIENTO, "T"),
    medicoHospital: max(L.PAD_MEDICO, "M"),
    fechaInicio: "2020-01-15",
    fechaFin: "2021-06-20",
  }));

  /* Form04: aceptación para poder firmar sin rellenar de nuevo */
  form.declarationsAccepted = true;
}
